/**
 * Vertragsmanagement API
 * REST-Api für das Conergos Vertragsmanagement Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@scorpius-forge.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContactData } from '@bo-client/shared/models/contactData';
import { UserRole } from '@bo-client/shared/models/userDto';
import { DocumentDto } from '@bo-client/shared/models/documentDto';
import { DevelopmentAreaInfo } from '@bo-client/shared/models/developmentAreas';
import {
  AuxInstallerPassModel,
  InstallerPassDto,
  InstallerPassModel
} from '@bo-client/shared/models/installerPassDto';
import { TenantDto } from '@bo-client/shared/models/tenantDto';
import { CompanyLocationDto } from '@bo-client/shared/models/companyLocations';
import { AreaTypesModel } from '@bo-client/shared/models/areaTypes';
import { BusinessPartner } from '@bo-client/shared/models/businessPartner';

export interface CreateOrUpdateTmUserDto {
  id?: number;
  externalId?: string;
  mail?: string;
  password?: string;
  tenantIds?: Array<string>;
  code?: string;
  resetPasswordToken?: string;
  activateAccountToken?: string;
  editTokenExpirationDate?: Date;
  confirmedMail?: boolean;
  contactData?: ContactData;
  roles?: Array<UserRole>;
  areaTypes?: AreaTypesModel[];
  businessPartner?: BusinessPartner;
  passes?: InstallerPassModel[];
}

export class AuxCreateOrUpdateTmUserDto {
  tmUser: CreateOrUpdateTmUserDto;
  auxPasses: AuxInstallerPassModel[];
}

export class AuxTmInstallerPassForCustomerCare {
  changedUser = false;
  auxPass: AuxInstallerPassModel;
  tmUser: CreateOrUpdateTmUserDto;
}

export const registrationInitialValues: CreateOrUpdateTmUserDto = {
  id: null,
  mail: '',
  password: '',
  tenantIds: ['thn', 'tsg'],
  contactData: {
    firstName: '',
    lastName: '',
    company: '',
    companyAddition: '',
    street: '',
    streetNo: '',
    city: '',
    zipCode: ''
  },
  businessPartner: {
    contactData: {
      firstName: '',
      lastName: ''
    }
  },
  passes: []
};

export const RegistrationPersonDaten: ContactData = {
  firstName: '',
  lastName: ''
};
